import * as types from './types';
import firebaseService from 'Services/firebaseService';

export function getProductData() {
  return (dispatch) => {
    firebaseService
      .getProductData()
      .then((response) => {
        dispatch({
          type: types.SET_PRODUCT_DATA,
          payload: response,
        });
      })
      .catch((error) => {
        // todo should have some dispatch error here
        console.warn('Error getting product data : ', error);
      });
  };
}
